"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const styles_1 = __importDefault(require("./styles"));
const IconButton = ({ id, children, disabled = false, label, ariaLabel, loading = false, onClick = () => { }, }) => {
    const classes = styles_1.default();
    return (react_1.default.createElement(core_1.Button, { id: id, "aria-label": ariaLabel, classes: { label: classes.iconLabel, root: classes.icon }, disabled: disabled, onClick: () => onClick() },
        loading ? react_1.default.createElement(core_1.CircularProgress, { size: 24 }) : children,
        label));
};
exports.default = IconButton;
